// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import { CustomThemeProvider } from './ThemeContext';
import { router } from './routes';
import ErrorBoundary from './components/ErrorBoundary';
import './index.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <CustomThemeProvider>
          <RouterProvider router={router} />
        </CustomThemeProvider>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);